module.exports = __webpack_public_path__ + "static/media/lakshay.4abca5f8.jpeg";